import { Component, OnInit, Input } from '@angular/core';
import { StockFilterService } from 'src/app/features/stock-screener/services/stock-filter.service';
import { ChangeDetectorRef } from '@angular/core';
import {
   ApiResponse,
   Hit,
} from 'src/app/models/sector-industries/sector-industries.model';
interface SortedValue {
   position: number;
   value: any; // Replace `any` with the actual type
   year: number;
}
@Component({
    selector: 'app-ratios',
    templateUrl: './ratios.component.html',
    styleUrls: ['./ratios.component.scss'],
    standalone: false
})
export class RatiosComponent implements OnInit {
   keys: any[] = [
      'netMargin',
      'quickRatio',
      'currentRatio',
      'peTTM',
      'price_to_earning',
      'psTTM',
      'pb',
      'fcfMargin',
      'payoutRatioTTM',
      'grossMargin',
      'roeTTM',
      'roa',
      'roaTTM',
      'roic',
      'inventoryTurnoverTTM',
      'receivablesTurnoverTTM',
      'assetTurnoverTTM',
      'longtermDebtTotalEquity',
      'totalDebtToTotalAsset',
      'longtermDebtTotalAsset',
      'totalDebtToTotalCapital',
      'operatingMargin',
   ];

   keys2: any[] = [
      'netMargin',
      'quickRatio',
      'currentRatio',
      'peTTM',
      'price_to_earning',
      'psTTM',
      'pb',
      'fcfMargin',
      'payoutRatioTTM',
      'grossMargin',
      'operatingMargin',
   ];
   keys3: any[] = [
      'longtermDebtTotalEquity',
      'totalDebtToTotalAsset',
      'longtermDebtTotalAsset',
      'totalDebtToTotalCapital',
   ];
   keys4: any[] = [
      'inventoryTurnoverTTM',
      'receivablesTurnoverTTM',
      'assetTurnoverTTM',
   ];
   keys5: any[] = ['roeTTM', 'roa', 'roaTTM', 'roic'];

   allDataAnnual: any[] = [];
   aDataQuarterly: any[] = [];
   bDataQuarterly: any[] = [];
   cDataQuarterly: any[] = [];
   dDataQuarterly: any[] = [];
   // quickRatioAnnualArray:any[]=[]
   // cashRatioAnnualArray:any[]=[]
   // peTtmAnnualArray:any[]=[]
   // psTtmAnnualArray:any[]=[]
   // fcfMarginAnnualArray:any[]=[]
   // payoutRatioAnnualArray:any[]=[]
   // grossMarginAnnualArray:any[]=[]
   // roeAnnualArray:any[]=[]
   // roaAnnualArray:any[]=[]
   // roaTtmAnnualArray:any[]=[]
   // roicAnnualArray:any[]=[]
   // inventoryTurnoverTtmAnnualArray:any[]=[]
   // receivablesTurnoverTtmAnnualArray:any[]=[]
   // assetTurnoverTtmAnnualArray:any[]=[]
   // longTermDebttoEquityAnnualArray:any[]=[]
   // debtToAssetAnnualArray:any[]=[]
   // longTermDebttoTotalAssestAnnualArray:any[]=[]
   // debtToCapitalAnnualArray:any[]=[]
   // pbAnnualArray:any[]=[]
   // netMarginAnnualArray:any[]=[]
   // operatingMarginAnnualArray:any[]=[]

   // quickRatioQuarterlyArray:any[]=[]
   // cashRatioQuarterlyArray:any[]=[]
   // peTtmQuarterlyArray:any[]=[]
   // psTtmQuarterlyArray:any[]=[]
   // fcfMarginQuarterlyArray:any[]=[]
   // payoutRatioQuarterlyArray:any[]=[]
   // grossMarginQuarterlyArray:any[]=[]
   // roeQuarterlyArray:any[]=[]
   // roaQuarterlyArray:any[]=[]
   // roaTtmQuarterlyArray:any[]=[]
   // roicQuarterlyArray:any[]=[]
   // inventoryTurnoverTtmQuarterlyArray:any[]=[]
   // receivablesTurnoverTtmQuarterlyArray:any[]=[]
   // assetTurnoverTtmQuarterlyArray:any[]=[]
   // longTermDebttoEquityQuarterlyArray:any[]=[]
   // debtToAssetQuarterlyArray:any[]=[]
   // longTermDebttoTotalAssestQuarterlyArray:any[]=[]
   // debtToCapitalQuarterlyArray:any[]=[]
   // pbQuarterlyArray:any[]=[]
   // netMarginQuarterlyArray:any[]=[]
   // operatingMarginQuarterlyArray:any[]=[]

   @Input() chartKey: string = '';
   @Input() price_to_earning: any[] = [];
   @Input() ticker: string = '';
   _isAnnual: boolean = true;
   setLoadingState: boolean = true;

   period: string[] = ['2020-12', '2021-12', '2022-12', '2023-12', '2024-12'];
   quartPeriod: string[] = ['2024-03', '2024-06', '2024-09', '2024-12'];

   annualDataLoaded: boolean = false;
   quarterlyDataLoaded: boolean = false;

   constructor(
      private financialService: StockFilterService,
      private cd: ChangeDetectorRef
   ) {}

   ngOnInit(): void {
      this.loadData();
   }
    async loadData(): Promise<void> {
       this.setLoadingState = true;

       // Fetch both annual and quarterly data in parallel
       await Promise.all([this.getAnnualData(), this.getQuarterlyData()]);

       this.setLoadingState = false;
    }
   changePeriod(periodValue: boolean): void {
      this.isAnnual = periodValue; // This will trigger the setter
      //console.log("Period changed:", periodValue);
   }
   set isAnnual(value: boolean) {
      this._isAnnual = value;
   }

   get isAnnual(): boolean {
      return this._isAnnual;
   }

   async getAnnualData() {
      try {
         const promises = [
            this.getActualAnnualData(this.keys, 'annual', this.allDataAnnual),
         ];
         await Promise.all(promises);
      } catch (error) {
         console.error('Error fetching annual data:', error);
      }
   }

   async getQuarterlyData() {
      try {
         const promises = [
            this.getActualQuarterlyData(
               this.keys2,
               'quarterly',
               this.aDataQuarterly
            ),
            this.getActualQuarterlyData(
               this.keys3,
               'quarterly',
               this.bDataQuarterly
            ),
            this.getActualQuarterlyData(
               this.keys4,
               'quarterly',
               this.cDataQuarterly
            ),
            this.getActualQuarterlyData(
               this.keys5,
               'quarterly',
               this.dDataQuarterly
            ),
         ];
         await Promise.all(promises);
      } catch (error) {
         console.error('Error fetching quarterly data:', error);
      }
   }

   async getActualAnnualData(
      keys: string[],
      timePeriod: string,
      targetArray: any[]
   ) {
      try {
         const ticker = this.chartKey;
         targetArray.length = 0; // Clear previous data

         const targetYears = [2020, 2021, 2022, 2023, 2024];
         let page = 1; // Start with page 1
         let perPage = 250; // Increased from 50 to 250
         let hasMoreData = true;
         let allHits: Hit[] = [];

         while (hasMoreData) {
            // Fetch data using the entire `keys` array
            const response = await this.financialService.getRatAnnualData2(
               ticker,
               keys,
               timePeriod,
               perPage,
               page
            );

            if (response?.hits) {
               allHits.push(...response.hits); // Collect all hits
            }

            // Check if more pages are available
            hasMoreData = response?.hits.length === perPage;
            page++; // Move to next page
         }

         // Process and map the data after collecting all pages
         keys.forEach((name) => {
            const yearMappedValues: { [year: number]: any | null } = {
               2020: null,
               2021: null,
               2022: null,
               2023: null,
               2024: null,
            };

            allHits.forEach((hit: Hit) => {
               const period = new Date(hit.document.period);
               const year = period.getFullYear();

               if (hit.document.name === name && targetYears.includes(year)) {
                  yearMappedValues[year] = hit.document.v;
               }
            });

            targetArray.push({ name, ...yearMappedValues });
         });

         this.cd.detectChanges();
         return targetArray;
      } catch (error) {
         this.setLoadingState = false;
         console.error('Error fetching data:', error);
         throw error;
      }
   }

   async getActualQuarterlyData(
      keys: string[],
      timePeriod: string,
      targetArray: any[]
   ) {
      try {
         const ticker = this.chartKey;
         targetArray.length = 0; // Clear previous data


         let perPage = 250; // Fetch max 250 records per API call
         let page = 1;
         let allHits: Hit[] = [];

         while (true) {
            // Fetch quarterly data for all keys at once
            const response = await this.financialService.getRatQuarterlyData2(
               ticker,
               this.quartPeriod,
               keys,
               timePeriod,
               perPage,
               page
            );

            if (response?.hits?.length) {
               allHits = [...allHits, ...response.hits];
            }

            // If less data returned than perPage, it means no more pages left
            if (!response?.hits || response.hits.length < perPage) break;
            page++; // Move to next page if more data exists
         }

         if (allHits.length === 0) {
            return targetArray;
         }

         // Find all unique quarters from the data dynamically
         const availableQuarters = new Set<string>();
         const availableYears = new Set<number>();

         allHits.forEach((hit: Hit) => {
            if (keys.includes(hit.document.name)) {
               const period = new Date(hit.document.period);
               const year = period.getFullYear();
               const month = period.getMonth() + 1;

               availableYears.add(year);

               let quarter = '';
               if (month >= 1 && month <= 3) quarter = `Q1'${year.toString().slice(-2)}`;
               else if (month >= 4 && month <= 6) quarter = `Q2'${year.toString().slice(-2)}`;
               else if (month >= 7 && month <= 9) quarter = `Q3'${year.toString().slice(-2)}`;
               else if (month >= 10 && month <= 12) quarter = `Q4'${year.toString().slice(-2)}`;

               if (quarter) {
                  availableQuarters.add(quarter);
               }
            }
         });

         // Convert to sorted array (latest quarters first), then take only 4 latest
         const sortedQuarters = Array.from(availableQuarters).sort((a, b) => {
            const aYear = parseInt('20' + a.split("'")[1]);
            const bYear = parseInt('20' + b.split("'")[1]);
            const aQuarter = parseInt(a.split("'")[0].substring(1));
            const bQuarter = parseInt(b.split("'")[0].substring(1));

            if (aYear !== bYear) return bYear - aYear; // Latest year first
            return bQuarter - aQuarter; // Latest quarter first
         });

         // Take only the 4 latest quarters and reverse to show latest on right
         const targetQuarters = sortedQuarters.slice(0, 4).reverse();

         const quarterlyDataMap = new Map<
            string,
            { [quarter: string]: number | null }
         >();

         // Initialize each key with empty quarterly data for all found quarters
         keys.forEach((name) => {
            const quarterData: { [quarter: string]: number | null } = {};
            targetQuarters.forEach(quarter => {
               quarterData[quarter] = null;
            });
            quarterlyDataMap.set(name, quarterData);
         });

         // Process all hits - now using all available years, not just 2024
         allHits.forEach((hit: Hit) => {
            const period = new Date(hit.document.period);
            const year = period.getFullYear();
            const month = period.getMonth() + 1;
            const name = hit.document.name;

            if (keys.includes(name) && availableYears.has(year)) {
               let quarter = '';
               if (month >= 1 && month <= 3) quarter = `Q1'${year.toString().slice(-2)}`;
               else if (month >= 4 && month <= 6) quarter = `Q2'${year.toString().slice(-2)}`;
               else if (month >= 7 && month <= 9) quarter = `Q3'${year.toString().slice(-2)}`;
               else if (month >= 10 && month <= 12) quarter = `Q4'${year.toString().slice(-2)}`;

               // Only set value if it's null (first occurrence) to prevent duplicates
               if (quarter && quarterlyDataMap.get(name)?.[quarter] === null) {
                  quarterlyDataMap.get(name)![quarter] = hit.document.v;
               }
            }
         });

         // Convert map to array format
         targetArray.push(
            ...keys.map((name) => ({
               name,
               ...quarterlyDataMap.get(name),
            }))
         );

         this.cd.detectChanges();
         return targetArray;
      } catch (error) {
         this.setLoadingState = false;
         console.error('Error fetching quarterly data:', error);
         throw error;
      }
   }
}
